const Index = r => require.ensure([], () => r(require('./Index')), 'group-xxminapp')
const Xbbd = r => require.ensure([], () => r(require('./xbbd')), 'group-xxminapp')

export default {//
	path: '/forxxminapp',
	component: Index,
	children: [
		{
			path: 'xbbd',
			name: 'Xbbd',
			component: Xbbd,
			meta: {
				title: '小白必读'
			}
		},
	]
}



// WEBPACK FOOTER //
// ./src/components/ForXiaoXiMinApp/router.js